<div class="flex items-center justify-between gap-4 p-4">
  <div class="flex items-center gap-4">
    <!-- Mobile menu button -->
    <button 
      class="lg:hidden p-2 rounded-md hover:bg-gray-100"
      (click)="onMenuToggle()"
    >
      <img src="/hamburger-button.svg" alt="Menu" class="w-6 h-6">
    </button>
    
    <img src="/FotoshopIcon.png" alt="Foto2Print Logo" class="w-14 h-14 rounded" />
    <span class="text-4xl font-bold text-gray-800">Foto2Print</span>
  </div>

  <app-user-menu />
</div>
